import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Calendar, FileText, Library } from 'lucide-react';
import LogoutButton from './auth/LogoutButton';

const routes = [
  { path: '/', icon: <LayoutDashboard size={24} />, label: 'Dashboard' },
  { path: '/workshops', icon: <Calendar size={24} />, label: 'Workshops' },
  { path: '/invoices', icon: <FileText size={24} />, label: 'Factures' },
  { path: '/bibliotheque', icon: <Library size={24} />, label: 'Bibliothèque' },
];

const Sidebar = () => {
  return (
    <aside className="group relative h-full bg-white border-r border-gray-200 shadow-sm transition-all duration-200 w-20 hover:w-48 flex flex-col px-4 py-6">
      {/* Logo */}
      <div className="mb-10 flex justify-center group-hover:justify-start transition-all w-full">
        <img
          src="/logos/logo.png"
          alt="Logo"
          className="h-10 w-10 object-contain"
        />
      </div>

      {/* Navigation */}
      <nav className="flex flex-col gap-6 w-full">
        {routes.map((route) => (
          <NavLink
            key={route.path}
            to={route.path}
            className={({ isActive }) =>
              `flex items-center text-gray-700 hover:text-[#623413] ml-3 transition-colors ${
                isActive ? 'text-[#623413] font-semibold' : ''
              }`
            }
          >
            <div className="w-12 flex justify-center">{route.icon}</div>
            <span className="overflow-hidden whitespace-nowrap transition-all duration-200 opacity-0 group-hover:opacity-100 group-hover:ml-2">
              {route.label}
            </span>
          </NavLink>
        ))}
      </nav>

      {/* Logout Button aligned like a route */}
      <div className="mt-auto w-full hidden group-hover:block">
        <div className="flex items-center text-gray-700 hover:text-red-600 transition-colors">
          <div className="w-12 flex justify-center" />
          <LogoutButton />
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
